module.exports = __webpack_public_path__ + "img/wechat-scan.a4b51bb8.png";